import styled from 'styled-components'
import { defaultTheme } from '../../styles/themes/defaultTheme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'

export const CheckSuccess = () => {
    const { t } = useTranslation('premeeting')

    return (
        <Styles>
            <div className="container">
                <div>{t('check-success.success')}</div>
                <div>{t('check-success.see-later')}</div>
                <br />
                <div>
                    <FontAwesomeIcon icon={['fal', 'bolt']} style={{ fontSize: '2.5em' }} />
                </div>
                <br />
                <button className="outlined" onClick={() => window.close()}>
                    <small>{t('check-success.close-window')}</small>
                </button>
            </div>
        </Styles>
    )
}

const Styles = styled.section`
    width: 100vw;
    height: 100vh;
    background-color: ${defaultTheme.color.midnightBlack};
    color: ${defaultTheme.color.white};
    text-align: center;
    overflow: auto;
    ::-webkit-scrollbar {
        width: 0px;
    }
    display: flex;
    flex-direction: column;

    & > .container {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 1.8em;

        @media (max-width: 768px) {
            padding: 20px;
        }
    }

    .outlined {
        background: 0;
        border: 0;
        color: ${defaultTheme.color.white};
        cursor: pointer;
        text-decoration: underline;
        font-size: 1em;
    }
`
